
<template>
  <div class="example">
    <quill-editor
        class="editor"
        :value="value"
        :options="options"
        @change="onEditorChange"
    />
  </div>
</template>

<script>
import { Quill, quillEditor } from 'vue-quill-editor'
import Compressor from 'compressorjs'
import ImageUploader from "quill-image-uploader";

Quill.register('modules/imageUploader', ImageUploader)

import fileAPI from '@/api/fileAPI'

export default {
  name: 'TextEditor',
  components: {
    quillEditor
  },
  props: {
      value: {
        type: String,
        default: '',
        required: true,
      },
      advanced: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: 'قم بكتابة المحتوى هنا...'
      },
      withImage: {
        type: Boolean,
        default: false,
      }
  },
  data() {
    return {
      options: {
        theme: 'snow',
        placeholder: this.placeholder,
        modules: {
          toolbar: {
            container: [],
          },
          imageUploader: {
            upload: (file) => {
              return new Promise((resolve, reject) => {
                if(file.size > 2 * 1024 * 1024) {
                  this.$notifyError('يجب ان يكون حجم الصورة اقل من 2MB')
                  reject('error')
                  return
                }
                const formData = new FormData()
                new Compressor(file, {
                  quality: 0.7,
                  maxWidth: '1280',
                  success: result => {
                    formData.append('image', result, file.name)
                    fileAPI.upload(formData)
                        .then(({data}) => resolve(data.path))
                        .catch(response =>  {
                          const msg = response && response.error ? response.error.message : "حدث خطأ"
                          this.$notifyError(msg)
                          reject(msg)
                        })
                  },
                  error: (error) => {
                    this.$notifyError('حدث خطأ')
                    reject(error)
                  },
                })
              })
            },
          }
        }
      }
    }
  },
  methods: {
    onEditorChange(value) {
      this.$emit('change', value.html)
      this.$emit('input', value.html)
    },
  },
  created () {
    if(this.advanced) {
      this.options.modules.toolbar.container = [
        ['bold', 'italic', 'underline', 'clean'],
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'direction': 'rtl' }, { 'align': [] }],
        [{ 'color': [] }, { 'background': [] }],
        ['link', 'image', 'video']
      ]
    } else {
      this.options.modules.toolbar.container = [
        ['bold', 'italic', 'underline', 'clean'],
        ['code-block'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'direction': 'rtl' }, { 'align': [] }],
      ]
      if(this.withImage) {
        this.options.modules.toolbar.container.push(['image'])
      }
    }
  },
}
</script>

<style lang="scss">
[dir=rtl] .ql-snow .ql-tooltip a.ql-action::after {
  margin-left: 16px;
  margin-right: initial;
}
[dir=rtl] .ql-snow .ql-tooltip::before {
  margin-right: 8px;
  margin-left: initial;
}
.ql-toolbar {
  border-radius: .5rem .5rem 0 0;
}
.ql-container {
  border-radius: 0 0 .5rem .5rem;
}
.ql-video {
  width: 500px;
  height: 390px;
  margin: auto;
}
.ql-direction {
  transform: scaleX(-1);
}
.ql-align {
  .ql-picker-label,
  .ql-picker-item {
    transform: scaleX(-1);
  }
}
</style>
